(function () {
  "use strict";

  const SCROLL_THRESHOLD = 300;

  function init() {
    const btn = document.getElementById("BackToTop");
    if (!btn) return;

    let ticking = false;

    let sticky = document.querySelector("sticky-add-to-cart");

    function updateForSticky() {
      if (!btn) return;
      const hasSticky =
        sticky &&
        sticky.classList &&
        sticky.classList.contains("sticky-atc--visible");
      if (hasSticky) btn.classList.add("back-to-top--with-sticky");
      else btn.classList.remove("back-to-top--with-sticky");
    }

    const stickyClassObserver = new MutationObserver(updateForSticky);

    function attachStickyObserver() {
      sticky = document.querySelector("sticky-add-to-cart");
      if (sticky) {
        stickyClassObserver.observe(sticky, {
          attributes: true,
          attributeFilter: ["class"],
        });
        updateForSticky();
      }
    }

    const bodyObserver = new MutationObserver((mutations) => {
      if (!sticky) {
        for (const m of mutations) {
          for (const node of m.addedNodes) {
            if (
              node.nodeType === 1 &&
              node.matches &&
              node.matches("sticky-add-to-cart")
            ) {
              attachStickyObserver();
              return;
            }
          }
        }
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
    attachStickyObserver();

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (window.scrollY > SCROLL_THRESHOLD) {
            btn.classList.add("back-to-top--visible");
          } else {
            btn.classList.remove("back-to-top--visible");
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    function scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    btn.addEventListener("click", scrollToTop);

    onScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
